import React from "react";
import SelectField from "./Fields/SelectField";
import TextField from "./Fields/TextField";
import TextArea from "./Fields/TextArea";
import CheckBox from './Fields/CheckBox';
import FieldValidation from './Validation/FieldValidation'
import { translate } from "../components/Language/Translate";
import CurrencyField from "./Fields/CurrencyField";


const FormFields = ({props}) => {
  const {
    fieldSettings, 
    variables, 
    setVariables,
    fieldErrors, 
    setFieldErrors, 
    serverError,
    setServerError
  } = props;

  const handleChange = e => {
    setFieldErrors({...fieldErrors, [e.target.name]:""});
    setVariables({...variables, [e.target.name]:e.target.value});
    setServerError && serverError && (() => setServerError(""))();
  };
  
  const validateField = (e) => {
    const {name, value} = e.target;
    const validation = new FieldValidation(name, value, fieldSettings, variables);
    const objValid = validation.isValid()
    if(objValid.valid){
      const newFieldErrors = {...fieldErrors};
      delete newFieldErrors[name];
      setFieldErrors({...newFieldErrors});
    }else{
      setFieldErrors({...fieldErrors, [name]: objValid.errMsg});
    };
};
  
const newProps = {
    ...props,
    handleChange,
    validateField,
  };
  const keys = Object.keys(variables);

  return(
    <>  
    {serverError && <div className="p-2" ><p className = "text-danger" >{translate(serverError)}</p></div>}
    {keys.map(k => {
            // console.log({k});
            if(!fieldSettings[k])return null;
            const {fieldType, note, note2} = fieldSettings[k];
            switch (fieldSettings[k].fieldType) {
                case "text":
                case "number":
                  return <TextField key={k} name={k} props={newProps} />
                case "select":
                  return <SelectField key={k} name={k} props={newProps} />
                case "textarea":
                  return <TextArea key={k} name={k} props={newProps}/>
                case "checkBox":
                case "boolean":
                  return <CheckBox name={k} key={k} props={newProps} />
               case "decimal":
                  return <p key={k}><b>{k}, {fieldSettings[k].fieldType} - {note} - {note2}</b></p>
                case "percent":
                  return <p key={k}><b>{k}, {fieldSettings[k].fieldType} - {note} - {note2}</b></p>
                case "currency":
                  return <CurrencyField key={k} name={k} props={newProps}/>
                default:
                  return <p key={k}>inside FormFields: Field  "{k}" is undefined:, {fieldSettings[k].fieldType}</p>;
            }
        })
      }
      {serverError && <div className="p-2" ><p className = "text-danger" >{translate(serverError)}</p></div>}
      </>
  )
};

export default FormFields;